import React, {useEffect} from 'react';
import {
    TEXTAREA_AUTO_GROW_MAX_H,
    TEXTAREA_REMARK_MIN_H,
    useAutoResizeTextarea,
} from "./useAutoResizeTextarea";
import "./textareaAutoGrow.css";

function TextAreaBasic({target, data, required, className, width, placeholder}) {

    const {ref, syncHeight} = useAutoResizeTextarea(data?.data?.[target], {
        minHeight: TEXTAREA_REMARK_MIN_H,
        maxHeight: TEXTAREA_AUTO_GROW_MAX_H,
    });

    useEffect(() => {
        if (required) {
            data.setData(prev => ({
                ...prev,
                required_validate: {...prev.required_validate, [target]: false}
            }));
        }
    }, []);

    const textareaLayoutStyle = {
        width: width ? width : '100%',
        padding: '4px 12px',
        textIndent: 0,
        lineHeight: 1.45,
        minHeight: TEXTAREA_REMARK_MIN_H,
        height: 'auto',
        maxHeight: TEXTAREA_AUTO_GROW_MAX_H,
        boxSizing: 'border-box',
    };

    const inputStyle = {
        ...textareaLayoutStyle,
        backgroundColor: required && (!data.data || !data.data[target] || data.data[target].trim() === '' || data.data[target] === '') ? '#ffe5e5' : '',
        border: required && (!data.data || !data.data[target] || data.data[target].trim() === '' || data.data[target] === '') ? '1px solid #e53939' : '',
        outline: 'none',
    };
    const basicStyle = {
        ...textareaLayoutStyle,
    };

    const handleInputChange = (event) => {
        if (required) {
            if (event.target.value.trim() !== '') {
                data.setData(prev => ({
                    ...prev,
                    [target]: event.target.value,
                    required_validate: {...prev.required_validate, [target]: true}
                }));
            } else {
                data.setData(prev => ({
                    ...prev,
                    [target]: event.target.value,
                    required_validate: {...prev.required_validate, [target]: false}
                }));
            }
        } else {
            data.setData(prev => ({
                ...prev,
                [target]: event.target.value,
            }));
        }
        requestAnimationFrame(syncHeight);
    };


    return (
        <textarea
            ref={ref}
            type={"text"}
            className={`basic-input focus input-style textarea-auto-grow ${className ? className : ""}`}
            value={!data.data || (!data.data[target] && data.data[target] !== 0) ? '' : data.data[target]}
            onChange={handleInputChange}
            placeholder={placeholder}
            style={required ? inputStyle : basicStyle}
        />
    );
}

export default TextAreaBasic;
